module.exports = __webpack_public_path__ + "img/LogoBialeKancelariaDM.9390581b.jpg";